<template>
	<div>
		<NavHeader/>
		<div class="main-header-content">
			<div class="container">
				<h3>Security Alert</h3>
			</div>
		</div>

		<div class="divider"></div>
		<div class="container">
			<div class="information-detail">
				<privacy-sidebar />

				<div class="information-content">
                    <img src="/static/commercial/img/security_information_detail.jpg" style="max-width: 100%; height: auto;">
				</div>
			</div>
		</div>


		<div class="divider"></div>
	</div>
</template>
<script>
	import DownloadApp from "../../shared/commercial/DownloadApp.vue";
	import NavHeader from "../../shared/commercial/NavHeader.vue";
	import PrivacySidebar from "../../components/privacysidebar.vue"
	import SignUpFooter from "../../shared/commercial/SignUpFooter.vue";
	export default {
		name: 'securiyawareness',
		components: { DownloadApp, NavHeader, SignUpFooter, PrivacySidebar },
	}
</script>